import { startAppListening } from '@app/store/listenerMiddleware';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { notify } from '@shared/notifications/notify';

import { toAppError } from './transformError';

const SUPPRESSED_CODES = new Set(['VALIDATION_ERROR', 'UNAUTHORIZED']);

/**
 * Auto-toast on any RTK Query **mutation** rejection.
 *
 * - Queries are deliberately skipped — pages handle their own error UI.
 * - `VALIDATION_ERROR` is skipped because `DynamicForm` surfaces
 *   field-level errors inline.
 * - `UNAUTHORIZED` is skipped because the reauth flow/redirect handles it.
 *
 * Call `installApiErrorNotifier()` once at module boot.
 */
export function installApiErrorNotifier(): void {
  startAppListening({
    predicate: (action) => isRejectedWithValue(action),
    effect: (action) => {
      const meta = (action as { meta?: { arg?: { type?: string } } }).meta;
      if (meta?.arg?.type !== 'mutation') return;

      const err = toAppError((action as { payload?: unknown }).payload);
      if (SUPPRESSED_CODES.has(err.code)) return;

      notify.error(err.message);
    },
  });
}
